module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', [_vm._v("Recent Titles by Pamela Oldfield from Severn House")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_c('em', [_vm._v("The Heron Saga")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("BETROTHED")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE GILDED LAND")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("LOWERING SKIES")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("THE BRIGHT DAWNING")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("ALL OUR TOMORROWS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("EARLY ONE MORNING")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("RIDING THE STORM")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("CHANGING FORTUNES")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("NEW BEGINNINGS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("MATTERS OF TRUST")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("DANGEROUS SECRETS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("INTRICATE LIAISONS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("TURNING LEAVES")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("HENRY’S WOMEN")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("SUMMER LIGHTNING")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("JACK’S SHADOW")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("FULL CIRCLE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("LOVING AND LOSING")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("FATEFUL VOYAGE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE LONGEST ROAD")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE FAIRFAX LEGACY")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("TRUTH WILL OUT")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE BIRTHDAY PRESENT")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE BOAT HOUSE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE PENNINGTONS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE GREAT BETRAYAL")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("ISABEL’S WEDDING")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11794cbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/alsoby.vue
// module id = 63
// module chunks = 0